export default __webpack_public_path__ + "static/media/White Hand Gem of Holy Storm.728f58ff.jpg";